import Service from '../Service'

const index = {

    // index
    getAllIndex(data) {
        return Service.get(`/api/index/all`, { headers: { Authorization: `Bearer ${data.token}` } });
    },

    searchIndex(data) {
        return Service.post(`api/index/search`, {
            keyword: data.keyword
        }, {
            headers: { Authorization: `Bearer ${data.token}` }
        });
    },

    getAllIndexPaginate(data) {
        let page = data.page ? data.page : 1;
        return Service.get(`/api/index?page=${page}`, { headers: { Authorization: `Bearer ${data.token}` } });
    },

    getIndex(data) {
        return Service.get(`/api/index/${data.id}`, { headers: { Authorization: `Bearer ${data.token}` } });
    },

    createIndex(data) {
        return Service.post(`/api/index`, {
            index_code: data.index_code,
            name_th: data.name_th,
            name_en: data.name_en,
            unit_id: data.unit_id
        }, {
            headers: { Authorization: `Bearer ${data.token}` }
        });
    },

    editIndex(data) {
        return Service.put(`/api/index/${data.id}`, {
            index_code: data.index_code,
            name_th: data.name_th,
            name_en: data.name_en,
            unit_id: data.unit_id
        }, {
            headers: { Authorization: `Bearer ${data.token}` }
        });
    },

    deleteIndex(data) {
        return Service.delete(`/api/index/${data.id}`, { headers: { Authorization: `Bearer ${data.token}` } });
    },


    // index group
    getAllIndexGroupPaginate(data) {
        let page = data.page ? data.page : 1;
        return Service.get(`/api/group-index?page=${page}`, { headers: { Authorization: `Bearer ${data.token}` } });
    },

    getIndexGroup(data) {
        return Service.get(`/api/group-index/${data.id}`, { headers: { Authorization: `Bearer ${data.token}` } });
    },

    createIndexGroup(data) {
        return Service.post(`/api/group-index`, {
            name_th: data.name_th,
            name_en: data.name_en,
            group_index: data.group_index
        }, {
            headers: { Authorization: `Bearer ${data.token}` }
        });
    },

    editIndexGroup(data) {
        return Service.put(`/api/group-index/${data.id}`, {
            name_th: data.name_th,
            name_en: data.name_en,
            group_index: data.group_index
        }, {
            headers: { Authorization: `Bearer ${data.token}` }
        });
    },

    deleteIndexGroup(data) {
        return Service.delete(`/api/group-index/${data.id}`, { headers: { Authorization: `Bearer ${data.token}` } });
    }

};

export default index;
